import { useEffect, useState } from "react";

export default function useLocalState(key, initial) {
    const [value, setValue] = useState(() => {
        if (typeof window !== undefined && window.localStorage) {
            const saved = window.localStorage.getItem(key);
            if (saved && saved !== 'undefined' && saved !== 'null') {
                try {
                    return JSON.parse(saved);
                } catch (error) {
                    console.warn(`Failed to parse localStorage value for key "${key}":`, saved);
                    return initial;
                }
            }
        }
        return initial;
    });

    useEffect(() => {
        if (window.localStorage && value !== undefined && value !== null) {
            try {
                window.localStorage.setItem(key, JSON.stringify(value));
            } catch (error) {
                console.warn(`Failed to save value to localStorage for key "${key}":`, error);
            }
        }
    }, [value, key]);

    return [value, setValue];
}
